var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.992 1.09881C10.4187 -0.593593 8.15953 1.7795 7.50033 2.58542C6.84393 1.77714 4.59272 -0.601627 2.00795 1.09881C0.919779 1.81447 0.403571 2.88241 0.514836 4.18662C0.775157 7.23662 4.48425 11.2071 7.38976 12.4724C7.40982 12.483 7.43128 12.4906 7.45321 12.4948C7.46954 12.4983 7.4861 12.5 7.50243 12.5C7.54301 12.5 7.58314 12.4894 7.61882 12.4686C10.5232 11.1993 14.225 7.23355 14.4851 4.18662C14.5966 2.88217 14.0799 1.81447 12.992 1.09881Z",
    fill: "#E3282A",
    stroke: "#E3282A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteActive);
export default __webpack_public_path__ + "static/media/favorite-active.c77f8e4c65d0c11f5db71fb8bc5778bd.svg";
export { ForwardRef as ReactComponent };